import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let TabComp;

class Tabs extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: TabComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/lyte-components/tab-comp" */
      "../../../components/javascript/lyte-components/tab-comp").then(function(res) {
        TabComp = res.TabComp;
      })
    );

    
;
  }
}

export { Tabs };
